import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../../../../store/selectors/text-submission-drawer.selectors'
import { Collapse } from 'antd'
import { getAnswerByQuestion } from '../../../../../../../../utils/question.helper'
import { textSubmissionDrawerActions } from '../../../../../../../../store/slices/text-submission-drawer.slice'

const QuestionsCollapse = ({ question, answers, ContentComponent }) => {
    const expandedQuestionIds = useSelector(textSubmissionDrawerSelectors.expandedQuestionIds)
    const dispatch = useDispatch()

    const items = question.children.map(question => {
        const answer = getAnswerByQuestion(answers, question)
        return {
            key: question.id,
            label: question.name || question.content,
            children: <ContentComponent question={question} answer={answer} />,
        }
    })

    const onChange = expandedQuestionKeys => {
        const numericKeys = expandedQuestionKeys.map(Number)
        dispatch(textSubmissionDrawerActions.setExpandedQuestionIds(numericKeys))
    }

    return <Collapse activeKey={expandedQuestionIds} onChange={onChange} items={items} size='small' bordered={false} />
}

export default QuestionsCollapse
